<template>
    <CompassDialog
        :visible.sync="visible"
        :title="title"
        :primaryAction="primaryAction"
        :secondaryActions="secondaryActions"
    >
        <p class="typographies-paragraph-medium-regular">
            {{ message }}
        </p>
    </CompassDialog>
</template>

<script>
export default {
    data() {
        return {
            visible: true,
            title: this.$t.__('email.SettingsEmailsTemplatesWarningEditionModal.title'),
            message: this.$t.__('email.SettingsEmailsTemplatesWarningEditionModal.message'),
        };
    },
    computed: {
        primaryAction() {
            return {
                label: this.$t.__(
                    'email.SettingsEmailsTemplatesWarningEditionModal.btn_label_leave_without_save',
                ),
                type: 'primary-destructive',
                action: () => EventBus.emit('settingsEmailsTemplatesWarningEditionModal:leave'),
            };
        },
        secondaryActions() {
            return [
                {
                    label: this.$t.__('common.actions.cancel'),
                    type: 'secondary',
                    action: () => EventBus.emit('settingsEmailsTemplatesWarningEditionModal:close'),
                },
            ];
        },
    },
};
</script>
